import React from 'react';
import { Helmet } from 'react-helmet';
// import renderLoader from '../../components/renderLoader';
// const ProductBanner = lazy(() => import('./components/ProductBanner'));
// const ProductCapabilitiesOverview = lazy(
//   () => import('./components/ProductCapabilitiesOverview'),
// );
// const ProductDigitalMenus = lazy(
//   () => import('./components/ProductDigitalMenus'),
// );
// const ProductOrderPay = lazy(() => import('./components/ProductOrderPay'));
// const ProductTestimonial = lazy(
//   () => import('./components/ProductTestimonial'),
// );
// const ProductPricing = lazy(() => import('./components/ProductPricing'));
//
// const ProductQRCode = lazy(() => import('./components/ProductQRCode'));
// const ProductDashboard = lazy(() => import('./components/ProductDashboard'));
// const ProductFeatures = lazy(() => import('./components/ProductFeatures'));
import ProductDigitalMenus from './components/ProductDigitalMenus';
import ProductBanner from './components/ProductBanner';
import ProductCapabilitiesOverview from './components/ProductCapabilitiesOverview';
import ProductOrderPay from './components/ProductOrderPay';
import ProductQRCode from './components/ProductQRCode';
import ProductTestimonial from './components/ProductTestimonial';
import ProductPricing from './components/ProductPricing';
import ProductDashboard from './components/ProductDashboard';
import ProductFeatures from './components/ProductFeatures';

const Product: React.FC = () => {
  return (
    // <Suspense fallback={renderLoader()}>
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          All-in-One Order & Payment Software for Restaurants | TableTab
        </title>
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="TableTab provides restaurants with mobile order and payment software to simplify operations, increase sales and profits, protect staff, and improve the guest experience."
        />
        <link rel="canonical" href="https://tabletab.io/product/" />
      </Helmet>
      <div>
        <ProductBanner />
        <ProductCapabilitiesOverview />
        <ProductDigitalMenus />
        <ProductQRCode />
        <ProductOrderPay className={'py-20 md:py-28 lg:py-32'} />
        <ProductTestimonial className={'-mt-20 lg:-mt-52'} />
        <ProductDashboard className={'py-14 lg:py-20'} />
        <ProductFeatures />
        <ProductPricing className={'py-20 lg:py-32 xl:py-40'} />
      </div>
    </>
    // </Suspense>
  );
};

export default Product;
